"use client";

import { cn } from "../../../lib";
import { resolvePipResizeCornerCursorClass } from "./pip-resize";
import type { PipResizeCorner } from "./pip-resize-config";

const SQ_CURSOR_INTENT_DATA_ATTRIBUTE = "data-sq-cursor-intent";

const PIP_RESIZE_CORNERS: PipResizeCorner[] = [
	"top-left",
	"top-right",
	"bottom-left",
	"bottom-right",
];

interface PictureInPictureResizeHandlesProps {
	hitSizePx: number;
	onResizePointerDown: (
		corner: PipResizeCorner,
	) => React.PointerEventHandler<HTMLElement>;
	onResizeDoubleClick: (
		corner: PipResizeCorner,
	) => React.MouseEventHandler<HTMLElement>;
}

export function PictureInPictureResizeHandles({
	hitSizePx,
	onResizePointerDown,
	onResizeDoubleClick,
}: PictureInPictureResizeHandlesProps) {
	return (
		<>
			{PIP_RESIZE_CORNERS.map((corner) => {
				const resizeIntent =
					corner === "top-left" || corner === "bottom-right"
						? "resize-nesw"
						: "resize-nwse";
				return (
					<div
						key={corner}
						className={cn(
							"absolute z-30 touch-none",
							resolvePipResizeCornerCursorClass(corner),
							corner === "top-left" && "left-0 top-0",
							corner === "top-right" && "right-0 top-0",
							corner === "bottom-left" && "left-0 bottom-0",
							corner === "bottom-right" && "right-0 bottom-0",
						)}
						{...{ [SQ_CURSOR_INTENT_DATA_ATTRIBUTE]: resizeIntent }}
						style={{
							width: hitSizePx,
							height: hitSizePx,
						}}
						onPointerDown={onResizePointerDown(corner)}
						onDoubleClick={onResizeDoubleClick(corner)}
					/>
				);
			})}
		</>
	);
}
